import PageWrapper from 'components/page/PageWrapper';
import {useTranslation} from 'react-i18next';
import List from 'components/board/List';
import { Link } from 'react-router';
import {useState, useEffect} from 'react';

import bg from 'assets/images/banner/banner03.jpg';
import Button from 'components/button/Button';
import { useNavigate } from 'react-router';

export default function Certifications(){
  const {t} = useTranslation();
  const navigate = useNavigate();
  const menuName= t('menu.sub-references');
  const path=[{url:'/projects', name:t('menu.main-projects')}, {url:'/projects', name:menuName}];
  const title = t('references.banner.title')
  const comment = t('references.banner.comment')

  const [login, setLogin] = useState(false);
  useEffect(()=>{
    console.log(localStorage.getItem('token'))
    if(localStorage.getItem('token')) setLogin(true);
    else setLogin(false);
  }, [login])

  const handleLogout = () => {
    localStorage.removeItem('token');
    setLogin(false);
  }

  const handleNavigate = () =>{
    navigate('/projects/editor');
  }

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center">
        <div className="flex flex-col lg:w-[1200px]">
          {login?
          <div className="pr-6 text-end">
              <Button handler={handleNavigate} className="mr-2">글쓰기</Button>
              <Button handler={handleLogout}>로그아웃</Button>
          </div>
          :null}
          <List type="projects" viewUrl={`/projects`}/>
        </div>
      </div>
    </PageWrapper>
  );
}